import { Box, Typography, Button, IconButton, ButtonBase  } from "@mui/material";
import { ReactComponent as EditIcon } from '../../img/edit_pencil.svg';
import { ReactComponent as AvatarIcon } from '../../img/avatar_temp.svg';
import OnboardingStatusHook from '../../pages/customhook/onboardingStatus';
import { colors } from '../../Theme/tokens';

export default function UserProfileInfo({setIsSaveClicked, isSaveClicked, setIsEdit, isEdit, isUserProfile}) {
    const userId = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).sub_id : ''
    const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : ""
    const { onboardingStatusText } = OnboardingStatusHook(`${process.env.REACT_APP_BASE_URL}users/${userId}/onboarding/status`);
    const isDisabled = !isUserProfile ? true : !onboardingStatusText;
    const handleEdit  =  () => {
        setIsEdit(true)
    }

    const handleCancel  =  () => {
        setIsEdit(false)
    }

    const handleSave = () => {
        setIsSaveClicked(true)
    }

    return (
<Box sx={{
    borderRadius: '18px',
    padding: { xs: '12px', sm: '16px', md: '20px' },
    display: 'flex',
    gap: { xs: '0', sm: '5px' },
    backgroundColor: colors.background.paper,
    justifyContent: 'space-between',
    flexDirection: { xs: 'column', md: 'row' },
    boxShadow: `0px 1px 5px 0px ${colors.border.card}`,
    flexWrap:"wrap"
}}>
    <Box sx={{ display: 'flex', gap: { xs: '12px', sm: '16px', md: '20px' }, alignItems: 'center' }}>
        {/* Avatar circle */}
        <Box
            sx={{
                cursor: 'pointer',
                width: { xs: 60, sm: 80, md: 100 },
                height: { xs: 60, sm: 80, md: 100 },
                borderRadius: '50%',
                backgroundColor: colors.primary.main,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                fontWeight: 700,
                fontSize: { xs: '16px', sm: '20px', md: '26px' },
                color: colors.primary.contrastText,
                userSelect: 'none',
            }}
        >
            {(userData?.name)
                ?.split(' ')
                .filter(Boolean)
                .slice(0, 2)
                .map(w => w[0].toUpperCase())
                .join('')}
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px', justifyContent: 'center' }}>
            <Typography variant='h2' sx={{ fontWeight: 600,fontSize: { xs: '18px', sm: '20px', md: '24px' }, lineHeight: { xs: '24px', sm: '30px', md: '37px' },
                    wordBreak: 'break-word', letterSpacing:"0.5%"}}>
                {userData?.name}
            </Typography>
            <Typography sx={{color: colors.text.gray, fontSize: { xs: '14px', sm: '16px', md: '16px' } }}>{userData?.email}</Typography>
        </Box>
    </Box>

    {isEdit ? (
        <Box sx={{
            display: 'flex',
            gap: '10px',
            alignSelf: { xs: 'stretch', sm: 'center' },
            justifyContent: { xs: 'flex-end', sm: 'flex-start' },
        }}>
            <Button
                variant="outlined"
                onClick={handleCancel}
                sx={{
                    color: colors.text.main,
                    borderRadius: '6px',
                    fontSize: { xs: '13px', sm: '14px' },
                    padding: { xs: '4px 12px', sm: '6px 16px' },
                }}
            >
                Cancel
            </Button>
            <Button
                variant="contained"
                disabled={isSaveClicked}
                onClick={handleSave}
                sx={{
                    color: colors.primary.contrastText,
                    backgroundColor: colors.primary.main,
                    borderRadius: '6px',
                    fontSize: { xs: '13px', sm: '14px' },
                    padding: { xs: '4px 12px', sm: '6px 16px' },
                    '&:hover': { backgroundColor: colors.primary.main },
                }}
            >
                Save
            </Button>
        </Box>
    ) : (
        <ButtonBase
            disabled={isDisabled}
            onClick={handleEdit}
            sx={{
                display: 'flex',
                alignSelf: { xs: 'flex-end', sm: 'center' },
                borderRadius: '6px',
                background: 'white',
                gap: '5px',
                height: { xs: '32px', sm: '36px', md: '40px' },
                padding: { xs: '0 6px 0 0', sm: '0 10px 0 0' },
                border: `1px solid ${colors.text.gray}`,
                opacity: isDisabled ? 0.5 : 1,
                cursor: isDisabled ? 'not-allowed' : 'pointer',
            }}
        >
            <Box sx={{ padding: { xs: '6px', sm: '8px' }, display: 'flex', alignItems: 'center' }}>
                <EditIcon sx={{ fontSize: { xs: '18px', sm: '20px', md: '24px' } }} />
            </Box>
            <Typography
                sx={{
                    fontWeight: 500,
                    fontSize: { xs: '13px', sm: '14px', md: '16px' },
                    color: colors.text.secondary,
                    letterSpacing: '5%',
                    lineHeight: { xs: '20px', sm: '22px', md: '25px' },
                    alignSelf: 'center',
                }}
            >
                Edit
            </Typography>
        </ButtonBase>
    )}
</Box>
    )
}